import React from 'react';
import { Button } from 'tamagui';
import { CobuStack, CobuText } from '@cobu/ui';
import { useNavigate } from 'react-router-dom';
import { Strings } from '../../constants/Strings';

interface EventEmptyStateProps {
  title: string;
  description: string;
  buttonText?: string;
}

export function EventEmptyState({
  title,
  description,
  buttonText = Strings.get().events.empty.discoverGroups,
}: EventEmptyStateProps) {
  const navigate = useNavigate();

  const handleButtonPress = () => {
    navigate('/groups');
  };

  return (
    <CobuStack flex={1} justifyContent="center" alignItems="center" padding="$8" backgroundColor="$cobuDarkBlue25" margin="$4" borderRadius="$2">
      <CobuText color="$cobuDarkBlue" fontSize="$4" fontWeight="bold" ta="center" mb="$3">
        {title}
      </CobuText>
      <CobuText color="$colorMuted" fontSize="$2" ta="center" mb="$6">
        {description}
      </CobuText>
      <Button
        backgroundColor="$cobuDarkBlue"
        borderRadius="$6"
        onPress={handleButtonPress}
        height={'$7'}
      >
        <CobuText color="$white" fontSize="$3" fontWeight="bold">
          {buttonText}
        </CobuText>
      </Button>
    </CobuStack>
  );
} 